import React from 'react'

import { Text } from '@cinch-labs/design-system'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import * as styles from './hero.module.css'

interface LabelProps {
  heading: string
  content: any
}

const HERO_IMG_SRC = `${getEnv(Env.StaticAssetsUrl)}/promise/hero-image.png`

const Hero: React.FC<LabelProps> = ({ heading, content }) => {
  return (
    <div className={styles.hero}>
      <div className={styles.header}>
        <Text oxford={true} element="h1" className={styles.heading}>
          {heading}
        </Text>
      </div>
      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          <img src={HERO_IMG_SRC} className={styles.image} alt="" />
        </div>
        <div className={styles.body}>{content}</div>
      </div>
    </div>
  )
}

export default Hero
